/*
 * <collection-list-select>
 *
 * Dropdown alternative to the PDP colourway grid (#Collection-List): each option
 * carries a product URL, so picking one navigates to that product.
 */
if (!customElements.get('collection-list-select')) {
  class CollectionListSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select) return;

      this.select.addEventListener('change', () => {
        if (this.select.value) window.location.href = this.select.value;
      });
    }
  }

  customElements.define('collection-list-select', CollectionListSelect);
}
